'use strict';

const outlineChipVariants = {
    ['default-outline']: 'blue-outline',
    ['blue-outline']: 'blue-outline',
    ['green-outline']: 'green-outline',
    ['grey-outline']: 'grey-outline',
    ['orange-outline']: 'orange-outline',
    ['purple-outline']: 'purple-outline',
    ['red-outline']: 'red-outline',
    ['yellow-outline']: 'yellow-outline',
};
const chipVariants = {
    default: 'blue',
    blue: 'blue',
    green: 'green',
    grey: 'grey',
    orange: 'orange',
    purple: 'purple',
    red: 'red',
    yellow: 'yellow',
    ...outlineChipVariants,
};

exports.chipVariants = chipVariants;
exports.outlineChipVariants = outlineChipVariants;
//# sourceMappingURL=types.js.map
